/* Action types with TypeScript type declaration */
export const PAGE_NUMBER = 'rpb2b-react/pagination/PAGE_NUMBER';
export type PAGE_NUMBER = typeof PAGE_NUMBER;

export const PAGE_SIZE = 'rpb2b-react/pagination/PAGE_SIZE';
export type PAGE_SIZE = typeof PAGE_SIZE;

export const TOTAL_ELEMENTS = 'rpb2b-react/pagination/TOTAL_ELEMENTS';
export type TOTAL_ELEMENTS = typeof TOTAL_ELEMENTS;

export const TOTAL_PAGES = 'rpb2b-react/pagination/TOTAL_PAGES';
export type TOTAL_PAGES = typeof TOTAL_PAGES;

export default {
  PAGE_NUMBER,
  PAGE_SIZE,
  TOTAL_ELEMENTS,
  TOTAL_PAGES
};
